import { CONSTS } from "../../../config/objectConst";
// Components
// Image, Icons
import imageDog from "../../../assets/image/snail-looking-for.png";
// Style
import "./style.scss";

const NoContactsYetTemplate = ({ isModal, handlerExportModal }) => (
  <div className="no-cont-template">
    <div className="no-cont-template-body">
      <span className="h-2 absolute-text">Ooops… No contacts to add!</span>
      <img src={imageDog} alt="snail" width={150} className="img-snail" />
      <a
        href={CONSTS.LINKEDIN_URL}
        className="btn-v1 semi-bold"
        target="_blank"
        rel="noopener noreferrer"
      >
        Search on <span className="linkedin-icon">&nbsp;</span>
      </a>
    </div>
  </div>
);

export default NoContactsYetTemplate;
